import Identified from "@mapmycustomers/shared/types/base/Identified";
import Named from "@mapmycustomers/shared/types/base/Named";

const itemToValueLabel = (item: Identified & Named) => ({
  label: item.name,
  value: item.id,
});

export default itemToValueLabel;
